module.exports = __webpack_public_path__ + "assets/img/guide-sm.7d1bf093.jpg";